// extracted by mini-css-extract-plugin
module.exports = {"field":"SearchField_field__EAhVM","element":"SearchField_element__xTcgH"};